var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.083 19.125 31.375Q13.125 25.75 9.312 21.646Q5.5 17.542 5.5 13.5Q5.5 10.583 7.5 8.583Q9.5 6.583 12.417 6.583Q14.083 6.583 16.104 7.521Q18.125 8.458 20 11.417Q21.917 8.458 23.896 7.521Q25.875 6.583 27.583 6.583Q30.5 6.583 32.5 8.583Q34.5 10.583 34.5 13.5Q34.5 17.542 30.688 21.646Q26.875 25.75 20.875 31.375Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteActive);
export default __webpack_public_path__ + "static/media/favorite_active.6cc35afadeb9c47a4b15106a8ac56f87.svg";
export { ForwardRef as ReactComponent };